import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { testApiConfig } from './config/api';
import Login from './components/Login';
import Register from './components/Register';
import CreateProgram from './components/CreateProgram';
import EditProgram from './components/EditProgram';
import Train from './components/training/train';
import PrivateRoute from './components/PrivateRoute';
import Home from './components/Home';
import ExerciseDatabase from './components/ExerciseDatabase';
import LandingPage from './components/LandingPage';


//CHECK IF API_URL IS SET
if (!process.env.REACT_APP_API_URL) {
  console.warn('REACT_APP_API_URL is not set in the environment variables');
}

function App() {
  // Test the API configuration
  const isConfigValid = testApiConfig();
  
  if (!isConfigValid) {
    console.error('API configuration is invalid!');
  }
  
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Private Routes */}
          <Route path="/home" element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          } />
          <Route path="/exercises" element={
            <PrivateRoute>
              <ExerciseDatabase />
            </PrivateRoute>
          } />
          <Route path="/create-program" element={
            <PrivateRoute>
              <CreateProgram />
            </PrivateRoute>
          } />
          <Route path="/programs/:programId/edit" element={
            <PrivateRoute>
              <EditProgram />
            </PrivateRoute>
          } />
          <Route path="/programs/:programId/sessions/:sessionId/train" element={
            <PrivateRoute>
              <Train />
            </PrivateRoute>
          } />

          {/* Catch-all redirect to home for authenticated users or landing for non-authenticated */}
          <Route path="*" element={
            <PrivateRoute>
              <Navigate to="/home" replace />
            </PrivateRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
